import { Layouts } from '@/layouts'

// --------------------------------------------------------------------------
// Porte cachée vers l'aperçu de la NOUVELLE UI (refonte).
// - Adresse discrète, non devinable, reliée nulle part dans l'application.
// - Réservée par IDENTITÉ : seuls les comptes de ALLOWLIST y accèdent.
//   Tout autre utilisateur (même en tapant l'adresse) est renvoyé vers l'accueil
//   => aucun autre client ne voit qu'une bascule existe.
// - Aucune modification des écrans existants : on ajoute seulement cette route.
// --------------------------------------------------------------------------

// Comptes autorisés (e-mail de connexion, en minuscules).
// Réservé au seul compte de Charly : aucun autre client ne voit la bascule.
const ALLOWLIST = ['charly.leggeri@limeare.com']

function getCurrentEmail() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return (tp.email || (tp.rl_profile && tp.rl_profile.username) || '').toLowerCase()
}

export const ATELIER_NEW_UI_PATH = '/atelier-7kx29'

export const atelierNewUiRoute = {
  path: ATELIER_NEW_UI_PATH,
  name: 'hz-atelier-new-ui',
  meta: {
    layout: Layouts.EMPTY,
    requireAuth: true,
    hideZendesk: true,
    noTitle: true,
  },
  component: () => import('@/views/NouvelleUiPreview.vue'),
  beforeEnter: (to, from, next) => {
    if (ALLOWLIST.includes(getCurrentEmail())) {
      next()
    } else {
      // Non autorisé : comportement identique à une adresse inexistante.
      next({ path: '/' })
    }
  },
}
